import { Modal, ModalProps } from 'modules/modal/ui/Modal'
import { Text } from 'shared/ui/common/Text'
import { Title } from 'shared/ui/common/Title'

import s from './TargetRiskPoolModal.module.scss'

export const TargetRiskPoolModal = ({ onClose }: ModalProps) => {
  return (
    <Modal width={580} onClose={onClose}>
      <Title className={s.title} isCentered>
        Target risk pool
      </Title>
      <Text isUppercased isCentered>
        under-collateralized pool
      </Text>
      <Text className={s.secondaryText} color="secondary" isCentered>
        Anonymous borrowers with good credit score.
        <br />
        Higher APR, Low collateral
      </Text>
      <Text isUppercased isCentered>
        Over-collateralized pool
      </Text>
      <Text className={s.secondaryText} color="secondary" isCentered>
        All borrowers. Low APR, High collateral
      </Text>
    </Modal>
  )
}
